var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.$emit('close-menu')}}},[_c('router-link',{attrs:{"to":{ name: 'home', params: { lang: _vm.$route.params.lang } }}},[_c('img',{staticClass:"header-logo",attrs:{"src":require("../assets/naghmeh-old-logo-temp-resized.png"),"alt":"Return to home"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7107cd29","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderLogo.vue
// module id = 86
// module chunks = 0